module.exports = __webpack_public_path__ + "media/images/twitter-e9801829202218c256285b91df342c99.svg";